import script from "./MenuBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuBackground.vue?vue&type=script&setup=true&lang=js"

import "./MenuBackground.vue?vue&type=style&index=0&id=76df107f&lang=scss&scoped=true"
import "./MenuBackground.vue?vue&type=style&index=1&id=76df107f&lang=scss"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/online-3d-editor-laozicloud3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76df107f"]])

export default __exports__